import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_imagemaint } from "../shared/data.service";

import { wsImageLibraryListInfo } from "../shared/wsImageLibraryListInfo";
import { wsImageLibrarySetDistrictParm } from "../shared/wsImageLibrarySetDistrictParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./imagesetdistrict.component.html",
	styleUrls: ["./imagesetdistrict.component.css"],
})
export class ImageSetDistrictComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_imagemaint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public isSU: boolean = false;
	public SelectedImageLibraryItem: wsImageLibraryListInfo;
	public SelectedSchoolID: number;
	public isDistrictImage: boolean = false;
	public isImageLocked: boolean = false;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isSU = this.dialogConfig.data.isSU;
		this.SelectedSchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedImageLibraryItem = this.dialogConfig.data.SelectedItem;

		if (this.SelectedImageLibraryItem.SchoolID > 0) {
			this.isDistrictImage = false;
		} else {
			this.isDistrictImage = true;
		}

		this.isImageLocked = this.SelectedImageLibraryItem.isImageLocked;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSet
	//
	//-----------------------------------------------------------------------------------------------------
	onSet() {
		let parms: wsImageLibrarySetDistrictParm = {
			ImageLibraryID: this.SelectedImageLibraryItem.ImageLibraryID,
			SchoolID: this.SelectedSchoolID,
			isDistrictImage: this.isDistrictImage,
			isImageLocked: this.isImageLocked,
		};

		this.isBusy = true;
		this.dataService.ImageLibrarySetDistrict(parms).subscribe((data) => this.ImageLibrarySetDistrict_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibrarySetDistrict_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibrarySetDistrict_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
